(function () {
  var H = 'product__action-buttons-btn--hidden';
  var MQ = window.matchMedia('(max-width: 749px)');

  function init(wrap) {
    if (wrap._pabInited) return;
    var track = wrap.querySelector('.product__action-buttons-track');
    var btnL = wrap.querySelector('.product__action-buttons-btn--left');
    var btnR = wrap.querySelector('.product__action-buttons-btn--right');
    if (!track || !btnL || !btnR) return;
    wrap._pabInited = true;

    function update() {
      if (!MQ.matches) {
        btnL.classList.add(H);
        btnL.setAttribute('hidden', '');
        btnR.classList.add(H);
        btnR.setAttribute('hidden', '');
        track.scrollLeft = 0;
        track.classList.remove('is-dragging');
        return;
      }
      var s = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      if (s <= 2) {
        btnL.classList.add(H);
        btnL.setAttribute('hidden', '');
      } else {
        btnL.classList.remove(H);
        btnL.removeAttribute('hidden');
      }
      if (max < 2 || s >= max - 2) {
        btnR.classList.add(H);
        btnR.setAttribute('hidden', '');
      } else {
        btnR.classList.remove(H);
        btnR.removeAttribute('hidden');
      }
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    if (typeof MQ.addEventListener === 'function') {
      MQ.addEventListener('change', update);
    } else if (typeof MQ.addListener === 'function') {
      MQ.addListener(update);
    }
    update();

    btnL.addEventListener('click', function () {
      if (!MQ.matches) return;
      track.scrollTo({ left: 0, behavior: 'smooth' });
    });
    btnR.addEventListener('click', function () {
      if (!MQ.matches) return;
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    });

    var prevX = 0,
      startX = 0,
      dragging = false,
      hasDragged = false,
      pendingId = null;

    track.addEventListener('pointerdown', function (e) {
      if (!MQ.matches) return;
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      prevX = e.clientX;
      startX = e.clientX;
      pendingId = e.pointerId;
      hasDragged = false;
    });

    track.addEventListener('pointermove', function (e) {
      if (!MQ.matches || pendingId === null) return;
      if (e.buttons === 0) {
        endDrag();
        return;
      }
      if (!dragging) {
        if (Math.abs(e.clientX - startX) < 5) return;
        dragging = true;
        track.setPointerCapture(pendingId);
        track.classList.add('is-dragging');
      }
      hasDragged = true;
      track.scrollTo({ left: track.scrollLeft + (prevX - e.clientX) * 0.6, behavior: 'instant' });
      prevX = e.clientX;
    });

    function endDrag() {
      dragging = false;
      pendingId = null;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          hasDragged = false;
        }
      },
      true,
    );

    track.addEventListener('dragstart', function (e) {
      if (!MQ.matches) return;
      e.preventDefault();
    });
  }

  function run() {
    document.querySelectorAll('.product__action-buttons').forEach(init);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  window.addEventListener('load', run);
})();
